import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  open(event) {
    event?.preventDefault()
    this.overlayTarget.classList.add("is-open")
    document.body.style.overflow = "hidden"
  }

  close(event) {
    if (event && event.target !== this.overlayTarget) return
    event?.stopPropagation()
    this.overlayTarget.classList.remove("is-open")
    document.body.style.overflow = ""
  }
}
